import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Locale } from './data/type/locale';
import { VoiceSearchPageComponent } from './page/voice-search-page/voice-search-page.component';
import { P01IntroPageComponent } from './page/p01-intro-page/p01-intro-page.component';
import { BrowseTitlesPageComponent } from './page/browse-titles-page/browse-titles-page.component';
import { WatchlistPageComponent } from './page/watchlist-page/watchlist-page.component';
import { RecommendationsPageComponent } from './page/recommendations-page/recommendations-page.component';

export enum RoutePath {
  'browse-titles' = 'browse-titles',
  'recommendations' = 'recommendations',
  'watchlist' = 'watchlist',
  'voice-search' = 'voice-search',
}

export const routes: Routes = [
  {
    path: `:locale`,
    component: P01IntroPageComponent,
  },
  {
    path: `:locale/${RoutePath['browse-titles']}`,
    component: BrowseTitlesPageComponent,
  },
  {
    path: `:locale/${RoutePath['recommendations']}`,
    component: RecommendationsPageComponent,
  },
  {
    path: `:locale/${RoutePath['watchlist']}`,
    component: WatchlistPageComponent,
  },
  {
    path: `:locale/${RoutePath['voice-search']}`,
    component: VoiceSearchPageComponent,
  },
  {
    path: '**',
    redirectTo: `/${Locale['en-us']}${document.location.search}`,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
